import API from '../dataApi';

// -- Guest Members -------------------------------------------------------------
export const getGuestMembers = (derasarId) => API.get('/guest-members', { params: { derasarId } });
export const addGuestMember = (data) => API.post('/guest-members', data);
export const updateGuestMember = (id, data) => API.put(`/guest-members/${id}`, data);
export const deleteGuestMember = (id) => API.delete(`/guest-members/${id}`);
